// NOTE: this should be combined with RBSelectField.js but there are some special cases.
// this seems to only be used with filter bars in claims and HCSA so renamed the
// component appropriatly to be clearer on what this does (MA)

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

import { Colors } from '../theme'

class ProvidersDropdownMenu extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    let defaultValue = props.defaultText ? 0 : props.data[0]
    this.state = {
      value: defaultValue,
      defaultText: props.defaultText || null
    }
  }

  handleChange (event, index) {
    const value = index.props.value
    this.setState({ value }, () => {
      this.props.sendValues({ [this.props.id]: value === 0 ? null : value })
    })
  }

  componentDidUpdate (prevProps) {
    if (this.props.selected !== prevProps.selected) {
      this.setState({ value: this.props.selected })
    }
  }

  render () {
    const props = this.props
    const data = props.data
    // const defaultValue = this.props.id === 'radius' && data.find(item => item.id === 20000)
    // const defaultText = props.defaultText || null
    // hack for radius
    // const defaultValue = this.props.id === 'radius' ? 1000 : 0
    const defaultValue = this.props.defaultValue || 0

    return (
      <FormControl style={{ width: props.fullWidth ? '100%' : 'auto' }}>
        <InputLabel
          htmlFor={props.id}
          error={!!props.errorText}
          style={{
            color: Colors.Palette.primaryTextColor
          }}
        >{props.label}</InputLabel>
        <Select
          id={this.props.id}
          value={this.state.value === this.state.defaultText ? 0 : this.state.value || defaultValue}
          onChange={this.handleChange}
          ref={(input) => { this.select = input }}
          style={{ width: props.fullWidth ? '100%' : 'auto' }}
          error={!!props.errorText}
        >
          {this.state.defaultText && <MenuItem key={0} value={0}>{this.state.defaultText}</MenuItem>}
          {data && data.map((item, i) => { return <MenuItem key={i + 1} value={item && item.id}>{item && item.text}</MenuItem> })}

        </Select>
        <FormHelperText error={!!props.errorText}>{props.errorText}</FormHelperText>
      </FormControl>
    )
  }
}

ProvidersDropdownMenu.propTypes = {
  data: PropTypes.array,
  defaultText: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  sendValues: PropTypes.func,
  defaultValue: PropTypes.number
}

export default ProvidersDropdownMenu



// WEBPACK FOOTER //
// ./src/controls/ProvidersDropdownMenu.js